import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function classFor<T extends string>(value: T, map: Record<T, string>, fallback = ''): string {
  return map[value] ?? fallback;
}
